import styled from 'styled-components';

export const Row = styled.div`
  display: flex;
  gap: 16px;
`;

export const Column = styled.div`
  flex: 1;
`;
